import { useMutation } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import { useTargetUidPayload } from './useTargetUidPayload';

export interface VoiceTestHistoryItem {
  role: 'user' | 'assistant';
  content: string;
}

export interface VoiceTestTurnInput {
  audioB64: string;
  audioMime: string;
  history: VoiceTestHistoryItem[];
}

export interface VoiceTestTurnResult {
  transcript: string;
  reply_text: string;
  tool_calls?: Array<{ name: string; args: Record<string, unknown>; result: unknown }>;
  audio_b64: string;
  audio_mime: string;
  ended?: boolean;
  note?: string;
}

/**
 * Push-to-talk turn against the voice-agent test endpoint.
 * Admin-target aware: the same hook works on `/admin/users/:uid/settings/test`.
 */
export function useVoiceTestTurn() {
  const adminPayload = useTargetUidPayload();
  return useMutation({
    mutationFn: async (input: VoiceTestTurnInput): Promise<VoiceTestTurnResult> => {
      const fn = httpsCallable<
        VoiceTestTurnInput & { uid?: string },
        VoiceTestTurnResult
      >(functions, 'voiceTestTurn');
      const r = await fn({ ...input, ...adminPayload });
      return r.data;
    },
  });
}
